import { render, staticRenderFns } from "./HeaderMain.vue?vue&type=template&id=04bd59de&scoped=true"
import script from "./HeaderMain.vue?vue&type=script&scoped=true&lang=js"
export * from "./HeaderMain.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./HeaderMain.vue?vue&type=style&index=0&id=04bd59de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bd59de",
  null
  
)

export default component.exports